"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Nov 26 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var SessionItem_1 = require("../model/SessionItem");

var SessionItemConverter_1 = require("./SessionItemConverter");
/**
 * Default implementation of WindowSessionConverter.
 *
 * @author JMt
 * @author MSu
 */


var SessionItemConverterImpl =
/*#__PURE__*/
function (_SessionItemConverter) {
  _inherits(SessionItemConverterImpl, _SessionItemConverter);

  function SessionItemConverterImpl() {
    _classCallCheck(this, SessionItemConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SessionItemConverterImpl).apply(this, arguments));
  }

  _createClass(SessionItemConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var converter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        documentType: source.documentType
      });
      return new SessionItem_1.SessionItem(conversions.documentToClassId(source), conversions.toClassReferenceId(source.sessionId), source.documentType, converter.toObject(source.document, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var converter = typescript_ioc_1.Container.get(DataObjectConverter_1.DataObjectConverter, {
        documentType: source.documentType
      });
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        sessionId: conversions.toDocumentReferenceId(source.sessionId),
        documentType: source.documentType,
        document: converter.toDocument(source.document, conversions)
      });
      return result;
    }
  }]);

  return SessionItemConverterImpl;
}(SessionItemConverter_1.SessionItemConverter);

exports.SessionItemConverterImpl = SessionItemConverterImpl;